
// Helper függvény hogy egy tömbből ki szedjük az adott modelt id alapján
Array.prototype.findByModelId = function(id) {
    for (let i = 0; i < this.length; ++i)
    {
        if (this[i].id === id)
        {
            return this[i]
        }
    }
    return null
}


// WEBPACK FOOTER //
// ./src/plugins/arrayHelpers.js